import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductSlidesPageRoutingModule } from './product-slides-routing.module';

import { ProductSlidesPage } from './product-slides.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProductSlidesPageRoutingModule
  ],
  declarations: [ProductSlidesPage]
})
export class ProductSlidesPageModule {}
